import { Link } from "react-router-dom";
import { Calculator, Upload, CheckCircle2, Truck } from "lucide-react";

const STEPS = [
  {
    icon: Calculator,
    title: "1. Wyceniasz online",
    text: "Podajesz wymiar, nakład i folię w kalkulatorze. Cenę netto i brutto widzisz od razu – bez czekania na kontakt handlowca.",
  },
  {
    icon: Upload,
    title: "2. Wysyłasz projekt",
    text: "Do zamówienia dołączasz plik wektorowy (PDF, AI, EPS, CDR, SVG). Jeśli masz tylko logo w innym formacie – sprawdzimy je i doradzimy.",
  },
  {
    icon: CheckCircle2,
    title: "3. Akceptujesz podglądy",
    text: "Przygotowujemy układ do druku i przesyłamy do akceptacji. Produkcję zaczynamy po Twoim potwierdzeniu.",
  },
  {
    icon: Truck,
    title: "4. Odbierasz naklejki",
    text: "Realizacja 3–7 dni roboczych od akceptacji. Wysyłka kurierem na terenie Polski i Unii Europejskiej.",
  },
];

/** How the B2B ordering process works – 4 steps from quote to delivery. */
const OrderSteps = () => (
  <section id="jak-zamowic" className="py-12 md:py-20 bg-secondary/40">
    <div className="container mx-auto px-4">
      <div className="max-w-3xl mb-8 md:mb-12">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3">
          Jak zamówić naklejki 3D – 4 kroki
        </h2>
        <p className="text-muted-foreground leading-relaxed">
          Cały proces prowadzimy mailowo i telefonicznie, a wycenę dostajesz natychmiast z kalkulatora.
        </p>
      </div>
      <ol className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {STEPS.map((s) => (
          <li key={s.title} className="rounded-2xl border border-border bg-card p-5">
            <s.icon className="w-8 h-8 text-accent mb-3" aria-hidden="true" />
            <h3 className="font-bold text-foreground mb-2">{s.title}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">{s.text}</p>
          </li>
        ))}
      </ol>
      <div className="mt-8">
        <Link
          to="/kalkulator"
          className="inline-flex gradient-gold text-accent-foreground font-bold px-6 py-3 rounded-lg hover:opacity-90 transition-opacity shadow-gold"
        >
          Zacznij od wyceny
        </Link>
      </div>
    </div>
  </section>
);

export default OrderSteps;
